import { useEffect, useRef, useState } from 'react';
import { useLang } from '../i18n';

export default function WhyUs() {
  const [visible, setVisible] = useState(false);
  const ref = useRef();
  const { t } = useLang();

  const reasons = [
    { number: '01', title: t.why1Title, body: t.why1Body },
    { number: '02', title: t.why2Title, body: t.why2Body },
    { number: '03', title: t.why3Title, body: t.why3Body },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="sm-section" style={{ background: '#fff' }} data-testid="why-super-muffler" ref={ref}>
      <div className="sm-container">
        <div className="reveal-item" style={visible ? { opacity: 1, transform: 'translateY(0)' } : {}}>
          <div className="section-label">{t.whyLabel}</div>
          <h2 className="section-title">{t.whyTitle}</h2>
        </div>
        <div className="why-grid">
          {reasons.map((r, i) => (
            <div key={i} className="why-item reveal-item" style={{ transitionDelay: `${i * 100}ms`, ...(visible ? { opacity: 1, transform: 'translateY(0)' } : {}) }}>
              <div className="why-number">{r.number}</div>
              <h3 className="why-title">{r.title}</h3>
              <p className="why-body">{r.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
